import { Box } from "@mui/material"

// TODO: Use in all pages except dashboard
function DisplayEntity({ children, entityId }) {
  return (
    <Box mt={4} sx={{ minWidth: "100%" }}>
      {entityId && children}
    </Box>
  )
}

export default DisplayEntity